import React, { useState } from "react";
import ReactTooltip from "react-tooltip";
import AddNewInputModal from "components/Metadata/AddNewInputModal";
import Translate from "helpers/Translate";

export default function Cog({ onSelectMenu }) {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <>
      <ReactTooltip />
      <i
        className="fas fa-cog settings"
        data-tip={Translate({ id: "add_dependent_input" })}
        onClick={() => setShowMenu(!showMenu)}
      ></i>
      {showMenu && (
        <AddNewInputModal
          onSelectMenu={inputType => {
            onSelectMenu(inputType);
            setShowMenu(!showMenu);
          }}
        />
      )}
    </>
  );
}
